import { NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
    selector: 'lpcr-user-menu-item',
    templateUrl: './user-menu-item.component.html',
    styleUrl: './user-menu-item.component.scss',
    imports: [
        NgIf, RouterLink
    ]
})
export class UserMenuItemComponent {
  @Input()
  public title: string = '';

  @Input()
  public icon: string = '';

  @Input()
  public route: string | string[] = '';
}
